import { handleActions } from 'redux-actions';
import {
  SET_ROLES_USER,
} from '@App/constantes';

const initialState = {
  list: [],
};

const reducer = handleActions({
  [SET_ROLES_USER]: (state: any, action: any) => {
    const { payload } = action;
    return {
      ...state,
      list: payload,
    };
  },
  // tslint:disable-next-line: align
}, initialState);

export default reducer;
